// src/components/ExpeditorsPage/ExpeditorDetailPage.jsx

import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { authFetch } from "../api/api";
import Card from "../UI/Card";
import { useTranslation } from "react-i18next";


const BASE_URL = process.env.REACT_APP_DJANGO_BACKEND;
const API_URL = `${BASE_URL}/api/expeditors/`;
const WAREHOUSES_URL = `${BASE_URL}/api/warehouses/`;

export default function ExpeditorDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [expeditor, setExpeditor] = useState(null);
  const [warehouses, setWarehouses] = useState([]);
  const [loading, setLoading] = useState(true);

  const { t } = useTranslation("ExpeditorsPage");

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);

        // expeditor
        const res = await authFetch(`${API_URL}${id}/`);
        if (!res.ok) throw new Error(`HTTP error ${res.status}`);
        const data = await res.json();
        setExpeditor(data);

        // warehouses
        const warehousesRes = await authFetch(WAREHOUSES_URL);
        if (!warehousesRes.ok) throw new Error("Ошибка загрузки складов");

        const warehousesData = await warehousesRes.json();

        const filtered = warehousesData.filter(
          (w) => Number(w.expeditor) === Number(id)
        );

        setWarehouses(filtered);
      } catch (err) {
        console.error("Ошибка загрузки:", err);
        setExpeditor(null);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [id]);

  if (loading) {
    return <div className="p-10">Loading...</div>;
  }

  if (!expeditor) {
    return <div className="p-10 text-red-500">Экспедитор не найден</div>;
  }

  return (
    <div className="p-10 max-w-5xl mx-auto">

      {/* HEADER */}
      <h1 className="text-3xl font-bold mb-6">
        🚚 {t("expeditor")} #{expeditor.id}
      </h1>

      {/* INFO */}
      <Card className="p-6 mb-6">
        <p><b>{t("name")}:</b> {expeditor.name || "-"}</p>
        <p><b>{t("type")}:</b> {expeditor.type || "-"}</p>
        <p><b>{t("comment")}:</b> {expeditor.comment || "-"}</p>
      </Card>

      {/* GRID */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

        {/* ORDERS */}
        <Card className="p-4">
          <h2 className="font-semibold mb-2">📦 {t("orders")}</h2>
          <p className="text-gray-500 text-sm">stub</p>
        </Card>

        {/* WAREHOUSES (CLICKABLE) */}
        <Card
          className="p-4 cursor-pointer hover:bg-gray-50 transition"
          onClick={() => navigate(`/expeditors/${id}/warehouses`)}
        >
          <h2 className="font-semibold mb-4">
            📍 {t("warehouses")}
          </h2>

          {warehouses.length === 0 ? (
            <p className="text-gray-500 text-sm">
              {t("no_warehouses")}
            </p>
          ) : (
            <div className="space-y-2">
              {warehouses.map((w) => (
                <div
                  key={w.id}
                  onClick={() => navigate(`/warehouses/${w.id}`)}
                  className="p-3 border rounded-lg bg-gray-50 hover:bg-gray-100 cursor-pointer transition"
                >
                  <p className="font-medium">
                    {w.name || t("no_name")}
                  </p>
                  <p className="text-sm text-gray-600">
                    {w.city_name || "-"} · {w.address_cn || "-"}
                  </p>
                </div>
              ))}
            </div>
          )}
        </Card>

        {/* FINANCE */}
        <Card className="p-4">
          <h2 className="font-semibold mb-2">💰 {t("finances")}</h2>
          <p className="text-gray-500 text-sm">stub</p>
        </Card>

        {/* STATS */}
        <Card className="p-4">
          <h2 className="font-semibold mb-2">📊 {t("statistics")}</h2>
          <p className="text-gray-500 text-sm">stub</p>
        </Card>

      </div>

    </div>
  );
}